export default {
  /**
   * Set Teacher application approval list.
   *
   * @param state
   * @param items
   */
  setTeacherLeaveApplicationApprovalList(state, items) {
    console.log("Items: ", items);
    state.items = items;
  },

  /**
   * Pagination.
   *
   * @param state
   * @param pagination
   */
  setTeacherLeaveApplicationApprovalListPagination(state, pagination) {
    console.log("Pagination: ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set current page.
   *
   * @param state
   * @param page
   */
  setTeacherLeaveApplicationApprovalListPage(state, page) {
    state.pagination.current_page = page;
  },

  /**
   * Change application filters
   * @param state
   * @param filters
   */
  setTeacherLeaveApplicationApprovalFilters(state, filters) {
    state.filters = filters;
  },

  /**
   *
   * @param state
   * @param isBusy
   */
  setTeacherLeaveApplicationApprovalBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
